import { Typography } from '@mui/material'
import { useTranslations } from 'next-intl'
import { forwardRef } from 'react'

import { categoryIcons } from '../icons'
import type { SearchCategory } from '../types'
import { QuickSearchListItem } from './QuickSearchListItem'

export type QuickSearchViewAllItemProps = {
  category: SearchCategory
  hiddenCount: number
  selected: boolean
  onSelect: () => void
}

export const QuickSearchViewAllItem = forwardRef<HTMLLIElement, QuickSearchViewAllItemProps>(
  function QuickSearchViewAllItem({ category, hiddenCount, selected, onSelect }, ref) {
    const t = useTranslations('quickSearch')

    return (
      <QuickSearchListItem ref={ref} selected={selected} onSelect={onSelect} icon={categoryIcons[category]}>
        <Typography variant="body2" noWrap>
          {t('moreResults', { count: hiddenCount })}
          <Typography component="span" variant="body2" sx={{ color: 'accent.main', ml: 2 }}>
            {t('viewAll')}
          </Typography>
        </Typography>
      </QuickSearchListItem>
    )
  }
)
